import * as React from "react"

import { cn } from "@/lib/utils"
import { SperrGrund } from "@/hilfe/Knopfhilfe"

// grund: wie am <Button> (Auftrag 8, R3) -- warum das Feld gesperrt ist. Ein
// gesperrtes Feld zeigt ihn über eine Hülle; ohne grund bleibt es, wie es war.
const Input = React.forwardRef(({ className, type, ...rest }, ref) => {
  const { grund, ...props } = rest
  const feld = (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
  if (props.disabled && Object.prototype.hasOwnProperty.call(rest, "grund")) {
    return <SperrGrund grund={grund} className={`w-full ${className || ""}`} testId={props["data-testid"]}>{feld}</SperrGrund>;
  }
  return feld;
})
Input.displayName = "Input"

export { Input }
